import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import { useSelector } from 'react-redux'
import { CreatePersonalTrainingSubscriptionTeacherService, UpdatePersonalTrainingSubscriptionTeacherService } from '../../services/class_booking/classBookingServices'
import SettingsMenu from '../staticscreens/SettingsMenu'
import BatchBookingMenu from '../batch_booking/BatchBookingMenu'
import { GetTeacherListService, GetTeacherSearchService } from '../../services/class_booking/TeacherServices'
import { GetSearchService } from '../../services/AuthServices'
import { GetFileStandardService } from '../../services/admin/FileStandardServices'
import { GetBatchesSlotService } from '../../services/class_booking/batchesSlotServices'
import { GetClientService,GetOfflineClientService } from '../../services/ClientServices'
import { GetClassRoomService } from '../../services/admin/ClassRoomServices'

function BatchSubscriptionCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const user = useSelector(state=>state.Auth)
  const isTeacher = user?.logged_user_type === 'Teacher'
  const studentLabel = (s) => isTeacher ? s?.name : `${s?.name} - [${s?.mobile}]`
  const {state} = useLocation()
  const {pathname} = useLocation()
  const modesArr = [{label:'Online',value:'online'},{label:'Offline',value:'offline'}]

  const path = pathname.split('/')[pathname.split('/').length - 1]
  
  const [data, setdata] = useState({teacher: '', batch: '', class: '', students: [],meet_link:'',remarks:'',mode:modesArr[1],class_room:''});
  const [error, seterror] = useState({teacher: '', batch: '', class: '', students: '',meet_link:'',remarks:'',mode:'',class_room:''});

  const [student,setstudent] = useState([])
  const [teacherArr,setteacherArr] = useState([])
  const [filter_standard,setfilter_standard] = useState([])
  const [batches_slots,setbatches_slots] = useState([])
  const [classroom,setclassroom] = useState([])
  
  
  // console.log("state",state)

  const navigate = useNavigate();

  useEffect(() => {
    if (path === 'edit' && state?._id !== null && state?._id !== undefined) {
      let d = state 
      let passData = {
        ...d,
        teacher:{label:d?.teacher?.name,value:d?.teacher?._id},
        students:d?.students?.map((s)=>({label:studentLabel(s),value:s?._id})),
        batch:{label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id},
        class:{label:d?.class?.label,value:d?.class?._id},
        class_room: d?.class_room?._id ? {label:`${d?.class_room?.label} [${d?.class_room?.name}]`,value:d?.class_room?._id} : '',
        mode:modesArr?.find((r)=>r?.value === d?.mode)
      }
      setstudent(passData?.student)
      setdata(passData)
    }

    getData()

  }, [state])


  async function getData(mode){
    const response = await GetFileStandardService()
    const response1 = await GetBatchesSlotService(mode ?? data?.mode?.value ?? data?.mode)
    const response2 = await GetClassRoomService(1,'','','')
     let arr = [];
      response?.data?.datas?.forEach((d) => {
        arr.push({
          label: d?.label,
          value: d?._id,
        });
      });
      setfilter_standard(arr);
      let arr1 = [];
  
      response1?.data?.datas?.forEach((d) => {
        arr1.push({
          label: `${formatTo12Hour(d?.start_time)} - ${formatTo12Hour(d?.end_time)}`,
          value: d?._id,
        });
      });
      setbatches_slots(arr1);

      let arr2 = [];

      response2?.data?.datas?.forEach((item)=>{
        arr2?.push({label:`${item?.label} [${item?.name}]`,value:item?._id})
      })
      setclassroom(arr2)
  }

  console.log("data?.classroom",data?.class_room)



  async function handlechange(e) {
    let {name,value} = e.target
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }



  async function submitform() {
    if (path === 'edit' && data?.mode?.value !== 'offline' && !data.meet_link) {
      seterror({ ...error, meet_link: 'This field is required *' })
    }else {
        let sendData = { ...data }
        sendData['batch'] = data?.batch?.value
        sendData['class'] = data?.class?.value
        sendData['teacher'] = data?.teacher?.value
        sendData['students'] = data?.students?.map((s)=>s?.value)

        if(data?.mode?.value){
          sendData['class_room'] = data?.class_room?.value
        }else{
          delete sendData.class_room
        }

        if(sendData?.mode?.value){
          sendData["mode"] = sendData?.mode?.value
        } else {
           sendData["mode"] = data?.mode?.value ?? data?.mode
        }
   
        if(path === 'edit'){
          sendData["id"] = state?._id
          const response = await UpdatePersonalTrainingSubscriptionTeacherService(sendData)
          if (response.status === 200) {
            navigate(-1)
            toast.success('Batch Booking Info Updated Successfully')
          }
        } else {
        const response = await CreatePersonalTrainingSubscriptionTeacherService(sendData)
        if (response.status === 200) {
          navigate(-1)
          toast.success('Batch Booking Info Created Successfully')
        }
      }
    }
  }



  async function handleSelect(e,e1){
    if(e1 === 'student'){
      const arr = e?.map(
        (ele) =>
          student?.find((r) => r?.value === ele) ??
          data?.students?.find((r) => r?.value === ele)
      );
      setdata({...data,students:arr})
      seterror({...error,students:''})
    }
    if(e1 === 'mode'){
      setdata({...data,mode:modesArr?.find((r)=>r?.value === e),batches_slots:[]})
      seterror({...error,mode:''})
      setstudent([])
      setbatches_slots([])
      getData(e)
    }
    if(e1 === 'class'){
      setdata({...data,class:filter_standard?.find((r)=>r?.value === e)})
      seterror({...error,class:''})
    }
    if(e1 === 'batch'){
      setdata({...data,batch:batches_slots?.find((r)=>r?.value === e)})
      seterror({...error,batch:''})
    }
    if(e1 === 'teacher'){
      setdata({...data,teacher:teacherArr?.find((r)=>r?.value === e)})
      seterror({...error,teacher:''})
    }
    if(e1 === 'class_room'){
      setdata({...data,class_room:classroom?.find((r)=>r?.value === e)})
      seterror({...error,class_room:''})
    }
  }

   const formatTo12Hour = (time) => {
      if (!time) return "";

      const [hours, minutes] = time.split(":");
      let h = parseInt(hours, 10);
      const ampm = h >= 12 ? "PM" : "AM";

      h = h % 12 || 12; // convert 0 -> 12
      return `${h}:${minutes} ${ampm}`;
  };

  async function handleSearch(value,e1){
    if(e1 === 'teacher'){
      // const response = await GetTeacherSearchService(value,1,'Batch',path === 'create' ? 'offline' : data?.mode?.value)
      const response = await GetTeacherSearchService(value,1,'Batch',data?.mode?.value || data?.mode)
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr.push({label:d?.name,value:d?._id})
      })
      setteacherArr(arr)
    }

     if(e1 === 'student'){
      if(data?.mode?.value === 'online' || data?.mode === 'online'){
      const response = await GetClientService(1, '', '', '','All Data','',value)
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr.push({label:studentLabel(d),value:d?._id})
      })
      setstudent(arr)
      } else {
        const response = await GetOfflineClientService(1, value, '', '','All Data',data?.classroom?.value ?? data?.classroom)
        let arr = []
        response?.data?.datas?.forEach((d)=>{
          arr.push({label:studentLabel(d),value:d?._id})
        })
        setstudent(arr)
      }
    }
 }
 
 console.log("data?.classroom",data?.classroom)
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
      {pathname === '/batches_booking/list/time_table/edit' ? <BatchBookingMenu /> : <SettingsMenu />} 
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full relative lg:w-[300px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Teacher Batch Booking Slot Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Teacher Batch Booking Slot details</b> assign to you!.</h6>



          {path === 'edit' && state?._id !== null && state?._id !== undefined &&
          <div className='relative'>
          {(state?.meet_link && state?.mode !== 'offline') && <h6 onClick={() => {
            const separator = state?.meet_link?.includes("?") ? "&" : "?";
            window?.open(`myacademy://join?room=${state?.meet_link}&role=teacher`)}}
             className='text-[14px] text-green-600 font-[600] text-[9px] cursor-pointer absolute right-0 top-1 underline underline'>Open Meet</h6>}
          {(state?.meet_link && state?.mode !== 'offline') && 
          <TextInput
            mandatory={true}
            label={'Meet Link'}
            variant="standard"
            name="meet_link"
            type="text"
            // readOnly={(roles?.includes('admin') || state?._id == undefined)}
            error={error.meet_link}
            value={data.meet_link}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />}
          </div>
          }


            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Teacher Info</h6>
                <Select
                  value={data.teacher} 
                  filterOption={false}
                  bordered={false}
                  showSearch
                  onSearch={(e)=>handleSearch(e,'teacher')}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'teacher')} 
                  options={teacherArr} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Standard </h6>
                <Select
                  value={data.class} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={filter_standard}
                  onChange={(e)=>handleSelect(e,'class')} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Batch </h6>
                <Select
                  value={data.batch} 
                  filterOption={false}
                  bordered={false}
                  options={batches_slots}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'batch')} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            {data.mode?.value === 'offline' &&
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Room</h6>
                <Select
                  value={data.class_room} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={classroom}
                  onChange={(e)=>handleSelect(e,'class_room')} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>} 



            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Students </h6>
                <Select
                  value={data.students} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  onSearch={(e)=>handleSearch(e,'student')}
                  mode="multiple"
                  onChange={(e)=>handleSelect(e,'student')} 
                  options={student} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 
  
          <ErrorComponent error={error?.type} /> 


             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Mode </h6>
                <Select
                  value={data.mode} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  disabled={!roles?.includes('admin')}
                  onChange={(e)=>handleSelect(e,'mode')} 
                  options={modesArr} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 


        

          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="remarks"
            type="text"
            error={error.remarks}
            value={data.remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

         
        <div className='mt-4 flex'>
       
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>


        </div>
        
       

      
      </div>

      
      </div> 

    </div>
  )
}

export default BatchSubscriptionCE